var _effectorFileName = "/src/shared/components/contact-modal/contact-modal.tsx";
import { useUnit } from 'effector-react';
import { useTranslation } from 'next-i18next';
import { ContactForm } from '@/shared/components/contact-form/contact-form';
import { $isContactFormSentSuccessfully, contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData, EntryPoint } from '@/shared/components/contact-form/types';
import { Modal } from '../modal/modal';
interface ContactModalProps {
  children?: React.ReactNode;
  entryPoint?: EntryPoint;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}
export const ContactModal = (props: ContactModalProps) => {
  const {
    children,
    entryPoint = 'DEFAULT',
    open,
    onOpenChange
  } = props;
  const {
    t
  } = useTranslation('common');
  const {
    isContactFormSentSuccessfully,
    onContactFormSend
  } = useUnit({
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully,
    onContactFormSend: contactFormDataSent
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Modal dialogTrigger={children} entryPoint={entryPoint} title={t('contactModal.title')} description={t('contactModal.description')} isModalSentSuccessfully={isContactFormSentSuccessfully} open={open} onOpenChange={onOpenChange} onModalClosed={() => {}}>
      <ContactForm entryPoint={entryPoint} onFormSubmit={handleContactFormSubmit} />
    </Modal>;
};